type LoggerLike = {
  info: (message: string, data?: Record<string, unknown>) => void;
};

export type SessionLatencyMark = {
  traceId: string;
  scope: string;
  phase: string;
  elapsedMs: number;
  sincePrevMs: number;
  sinceClientStartMs?: number;
};

function getNowMs(): number {
  return Date.now();
}

export function createSessionLatencyTraceId(): string {
  if (typeof globalThis.crypto?.randomUUID === "function") {
    return globalThis.crypto.randomUUID();
  }

  return `trace_${Math.random().toString(36).slice(2, 10)}_${getNowMs().toString(36)}`;
}

export function parseLatencyStartMs(value: string | number | null | undefined): number | undefined {
  if (value === null || value === undefined || value === "") {
    return undefined;
  }

  const parsed = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return undefined;
  }

  return Math.floor(parsed);
}

export function createSessionLatencyTrace({
  logger,
  scope,
  traceId,
  clientStartMs,
}: {
  logger: LoggerLike;
  scope: string;
  traceId?: string;
  clientStartMs?: number;
}) {
  const resolvedTraceId = traceId || createSessionLatencyTraceId();
  const startedAtMs = getNowMs();
  let lastMarkAtMs = startedAtMs;

  return {
    traceId: resolvedTraceId,
    clientStartMs,
    mark(phase: string, data?: Record<string, unknown>): SessionLatencyMark {
      const nowMs = getNowMs();
      const payload: SessionLatencyMark & Record<string, unknown> = {
        traceId: resolvedTraceId,
        scope,
        phase,
        elapsedMs: Math.max(0, nowMs - startedAtMs),
        sincePrevMs: Math.max(0, nowMs - lastMarkAtMs),
      };

      if (typeof clientStartMs === "number") {
        payload.sinceClientStartMs = Math.max(0, nowMs - clientStartMs);
      }

      if (data) {
        Object.assign(payload, data);
      }

      lastMarkAtMs = nowMs;
      logger.info("[LATENCY_TRACE]", payload);
      return payload;
    },
  };
}
